import type { Role } from "@prisma/client"

export const ROLE = {
  TEAM_ADMIN: "Company Admin",
  TEAM_MEMBER: "Company Member",
} as const

export const ROLE_OPTIONS: { label: string; value: Role }[] = [
  { value: "TEAM_MEMBER", label: ROLE.TEAM_MEMBER },
  { value: "TEAM_ADMIN", label: ROLE.TEAM_ADMIN },
]
